var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6967 134.999L83.0145 134.109C83.0145 134.109 83.3716 120.537 78.4608 119.584C75.2464 115.841 78.9358 -40.2095 90.6861 119.052C88.4567 120.183 86.7508 122.132 85.9253 124.491C85.4828 127.976 85.4062 131.498 85.6967 134.999Z",
    fill: "url(#paint0_linear_346_143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1469 121.889C94.2885 116.513 99.7576 109.22 102.919 100.859C106.08 92.4979 106.803 83.4112 105.005 74.6553C99.7544 51.4939 87.322 43.8795 85.9826 40.9722C84.8271 39.1619 83.8408 37.2491 83.0361 35.2578L84.0254 99.7916C84.0254 99.7916 81.9754 119.514 87.1469 121.889Z",
    fill: "url(#paint1_linear_346_143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6498 122.749C81.6498 122.749 59.7885 107.859 61.0528 81.5191C61.1707 73.5783 62.9914 65.7553 66.3919 58.5785C69.7924 51.4017 74.6934 45.0383 80.764 39.918C81.4734 39.3153 82.0371 38.5596 82.4125 37.7079C82.788 36.8561 82.9656 35.9303 82.9319 35C84.2927 37.9286 84.0712 78.7261 84.2141 83.4977C84.7677 102.059 83.1819 119.245 81.6498 122.749Z",
    fill: "url(#paint2_linear_346_143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_143",
    x1: 67.6664,
    y1: 85.8984,
    x2: 98.4946,
    y2: 96.3598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_143",
    x1: 78.9716,
    y1: 34.7967,
    x2: 92.6006,
    y2: 119.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_143",
    x1: 59.1723,
    y1: 84.1264,
    x2: 95.7469,
    y2: 71.8775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoImg);
export default __webpack_public_path__ + "static/media/mongoImg.9f8dcac3885e3d281902ff0f0bc1ca17.svg";
export { ForwardRef as ReactComponent };